import React from 'react'
import { Col, FormControl } from 'react-bootstrap'
import LabelCustomSmall from '../../../../label-custom-small'

export default function CostCard({ isRead, dataDetail }) {
  return (
    <>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          Cost Number
        </LabelCustomSmall>
        {!isRead ? (
          <FormControl disabled value={dataDetail?.cost_number} />
        ) : (
          <div className="fw-light small">{dataDetail?.cost_number ?? '-'}</div>
        )}
      </ColFrom>
      <ColFrom>
        <LabelCustomSmall className={`${!isRead ? 'fw-light' : 'fw-bold'}`}>
          Cost Name
        </LabelCustomSmall>
        {!isRead ? (
          <FormControl
            disabled
            value={`${dataDetail?.cost_name_en} (${dataDetail?.cost_name_th})`}
          />
        ) : (
          <>
            <div className="fw-light small">
              {dataDetail?.cost_name_en ?? '-'} (
              {dataDetail?.cost_name_th ?? '-'})
            </div>
          </>
        )}
      </ColFrom>
    </>
  )
}

const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={3} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
